import axios from '@/lib/axios';
import { MonthlySalesTarget, UserInvitation, Workspace } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0330. チーム月間売上目標登録
 * [POST] /workspaces/:identifier/teams/:team_id/monthly_sales_targets
 */
type Props = {
  identifier: string;
  team_id: number;
  year_month: number;
  amount: number;
};
const createMonthlySalesTarget = (props: Props): Promise<MonthlySalesTarget> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/monthly_sales_targets`, props);
};

export const useCreateMonthlySalesTarget = () => {
  return useMutation({
    mutationFn: createMonthlySalesTarget,
  });
};
